import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { trackPageView, setUserData } from "../Analytics/Analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const user = useSelector((state) => state.user.user);
  const isLogged = useSelector((state) => state.user.isLogged);

  // Consolidated tracking for user identification and page views
  useEffect(() => {
    // 1. Identification: Ensure GA4 and Clarity know who the user Is
    if (isLogged && user) {
      const userId = user.id || user.email;
      const userName =
        `${user.first_name || ""} ${user.last_name || ""}`.trim();
      const organizationName = user.organization_name || "";

      // React GA4 identification (Centralized)
      setUserData(userId, user.first_name, organizationName);

      // Microsoft Clarity identification
      if (window.clarity) {
        window.clarity("identify", userId);
        window.clarity("set", "user_name", userName);
        window.clarity("set", "organization", organizationName);
        //console.log("Analytics: Identified user in Clarity", {
        //   userId,
        //   userName,
        //   organizationName,
        // });
      }
    }

    // 2. Page Tracking: Fires on every route change OR user state change
    // Since setUserData (above) is called first, the module-level cache in Analytics.js
    // will be populated before trackPageView executes.
    trackPageView(location.pathname + location.search);
  }, [location, user, isLogged]);

  return null;
};

export default AnalyticsTracker;
